// extracted by mini-css-extract-plugin
export default {"root":"NoMatchMessage-root-99754c6976d1c7223f40262047219037"};